import stuckAccountsDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const stuckAccountsReducer = stuckAccountsDispatcher(initialState, {
  [stuckAccountsDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [stuckAccountsDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [stuckAccountsDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default stuckAccountsReducer;
